if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.addEventListener('click', (event) => {
          const control = event.target.closest('[data-media-step]');
          if (control) this.stepMedia(control.dataset.mediaStep);
        });
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }

      stepMedia(direction) {
        const container = this.querySelector('[role="document"]');
        const mediaItems = Array.from(container.querySelectorAll('[data-media-id]'));
        const currentIndex = mediaItems.findIndex((media) => media.classList.contains('active'));
        if (currentIndex < 0) return;

        const nextIndex = direction === 'next' ? currentIndex + 1 : currentIndex - 1;
        if (nextIndex < 0 || nextIndex >= mediaItems.length) return;

        mediaItems[currentIndex].classList.remove('active');
        mediaItems[nextIndex].classList.add('active');
        mediaItems[nextIndex].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        this.updateMediaControls(nextIndex, mediaItems.length);
      }

      updateMediaControls(activeIndex, mediaCount) {
        if (activeIndex < 0) return;

        this.querySelector('[data-media-current]').textContent = activeIndex + 1;
        this.querySelector('.product-media-modal__nav--previous').disabled = activeIndex === 0;
        this.querySelector('.product-media-modal__nav--next').disabled = activeIndex === mediaCount - 1;
      }
    }
  );
}
